<form [formGroup]="form" novalidate>
   <div class="mb-3">
      <label for="cardNumber" class="form-label fw-bold">Card Number</label>
      @if (form.get('cardNumber')?.valid && ccImgUrl()) {
      <img [src]="ccImgUrl()" class="cc-img" alt="Card type" />
      }
      <input id="cardNumber"
             type="text"
             class="form-control"
             formControlName="cardNumber"
             inputmode="numeric"
             maxlength="19"
             autocomplete="cc-number" />
      @if (form.get('cardNumber')?.touched && form.get('cardNumber')?.invalid) {
      <em class="error-msg-block">Enter a valid card number.</em>
      }
   </div>

   <div class="mb-3">
      <label for="cardholderName" class="form-label fw-bold">Cardholder Name</label>
      <input id="cardholderName"
             type="text"
             class="form-control"
             formControlName="cardholderName"
             maxlength="100"
             autocomplete="cc-name" />
      @if (form.get('cardholderName')?.touched && form.get('cardholderName')?.invalid) {
         <em class="error-msg-block">Enter the cardholder name.</em>
      }
   </div>

   <div class="row g-2 mb-3">
      <div class="col-4">
         <label for="expirationMonth" class="form-label fw-bold">Exp. Month</label>
         <input id="expirationMonth"
                type="number"
                class="form-control"
                formControlName="expirationMonth"
                placeholder="MM"
                min="1"
                max="12"
                autocomplete="cc-exp-month" />
      </div>
      <div class="col-4">
         <label for="expirationYear" class="form-label fw-bold">Exp. Year</label>
         <input id="expirationYear"
                type="text"
                class="form-control"
                formControlName="expirationYear"
                placeholder="YY"
                inputmode="numeric"
                maxlength="2"
                autocomplete="cc-exp-year" />
      </div>
      <div class="col-4">
         <label for="cvv" class="form-label fw-bold">CVV</label>
         <input id="cvv"
                type="password"
                class="form-control"
                formControlName="cvv"
                maxlength="4"
                inputmode="numeric"
                autocomplete="cc-csc" />
      </div>
      @if (form.touched && (form.get('expirationMonth')?.invalid || form.get('expirationYear')?.invalid)) {
         <div class="col-12">
            <em class="error-msg-block">Enter a valid expiration month (MM) and year (YY).</em>
         </div>
      }
      @if (form.touched && form.errors?.['cardExpired']) {
         <div class="col-12">
            <em class="error-msg-block">Card is expired.</em>
         </div>
      }
      @if (form.get('cvv')?.touched && form.get('cvv')?.invalid) {
         <div class="col-12">
            <em class="error-msg-block">Enter a valid CVV (3 or 4 digits).</em>
         </div>
      }
   </div>
</form>
